// extracted by mini-css-extract-plugin
module.exports = {"container":"e_BD","link":"e_CD","lastLink":"e_DD","arrow":"e_ED"};